import { render, staticRenderFns } from "./EventHighlightsGrid.vue?vue&type=template&id=14025a40&scoped=true"
import script from "./EventHighlightsGrid.vue?vue&type=script&lang=ts"
export * from "./EventHighlightsGrid.vue?vue&type=script&lang=ts"
import style0 from "./EventHighlightsGrid.vue?vue&type=style&index=0&id=14025a40&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14025a40",
  null
  
)

export default component.exports